import './App.css';
import { Routes, Route } from "react-router-dom";
import Home from './Pages/Home/Home';
import Details from './Pages/Details';
import Blog from './Pages/Blog/Blog';
import Navbar from './Pages/Navbar';
import { useEffect, useState } from 'react';
import { css } from "@emotion/react";
import { HashLoader } from 'react-spinners';

const override = css`
  display: block;
  margin: 0 auto; 
  border-color: red;
`;

function App() {
  const [loading, setLoading] = useState()
  useEffect(() => {
    setLoading(true)
    setTimeout(() => {
      setLoading(false)
    }, 2000)
  }, [])
  return (
    <div className=''>
      {
        loading ?
          <div className='flex items-center h-full w-full'>
            <HashLoader color={'green'} loading={loading} css={override} size={200} />
          </div>
          :
          <>
            <Navbar></Navbar>
            <Routes>
              <Route path='/' element={<Home></Home>}></Route>
              <Route path='/blog' element={<Blog></Blog>}></Route>
              <Route path='/projects/:id' element={<Details></Details>}></Route>
            </Routes>
          </>

      }
    </div>

  );
}

export default App;
